import { cva } from "cva";

export const expandingMenuStyles = cva({
  base: "flex flex-col border-b-1 border-border-decorative first:border-t-1 transition-colors duration-220 ease-out-quad",
  variants: {
    expanded: {
      true: "bg-surface-1",
      false: "bg-surface",
    },
  },
});
